'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var qs = require('qs');

exports.WoodyLogLevel = void 0;
(function (WoodyLogLevel) {
    WoodyLogLevel[WoodyLogLevel["ERROR"] = 0] = "ERROR";
    WoodyLogLevel[WoodyLogLevel["WARN"] = 1] = "WARN";
    WoodyLogLevel[WoodyLogLevel["INFO"] = 2] = "INFO";
    WoodyLogLevel[WoodyLogLevel["DEBUG"] = 3] = "DEBUG";
    WoodyLogLevel[WoodyLogLevel["LOG"] = 4] = "LOG";
})(exports.WoodyLogLevel || (exports.WoodyLogLevel = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

var is2xx = function (code) {
    return code >= 200 && code <= 299;
};

var Logger = /** @class */ (function () {
    function Logger(name, level) {
        if (level === void 0) { level = exports.WoodyLogLevel.ERROR; }
        this.name = name;
        this.level = level;
    }
    Logger.prototype.setLevel = function (level) {
        this.level = level;
    };
    Logger.prototype.getLevel = function () {
        return this.level;
    };
    // This is defined like this to allow for easier addition of new levels without breaking the code
    // If we didn't care about that, we could just convert the ENUM value to a string and use that as the function name
    Logger.prototype.getLogFunction = function (level) {
        switch (level) {
            case exports.WoodyLogLevel.ERROR:
                return console.error;
            case exports.WoodyLogLevel.WARN:
                return console.warn;
            case exports.WoodyLogLevel.INFO:
                return console.info;
            case exports.WoodyLogLevel.DEBUG:
                return console.debug;
            case exports.WoodyLogLevel.LOG:
                return console.log;
            default:
                return console.log;
        }
    };
    Logger.prototype.logPrefix = function () {
        return "[".concat(this.name, "] ").concat(new Date().toISOString(), ": ");
    };
    Logger.prototype.logToConsole = function (level, data) {
        if (level > this.level) {
            return;
        }
        var logFunction = this.getLogFunction(level);
        logFunction(this.logPrefix(), data);
    };
    Logger.prototype.error = function (data) {
        this.logToConsole(exports.WoodyLogLevel.ERROR, data);
    };
    Logger.prototype.warn = function (data) {
        this.logToConsole(exports.WoodyLogLevel.WARN, data);
    };
    Logger.prototype.info = function (data) {
        this.logToConsole(exports.WoodyLogLevel.INFO, data);
    };
    Logger.prototype.debug = function (data) {
        this.logToConsole(exports.WoodyLogLevel.DEBUG, data);
    };
    Logger.prototype.log = function (data) {
        this.logToConsole(exports.WoodyLogLevel.LOG, data);
    };
    return Logger;
}());

var WoodyResponse = /** @class */ (function () {
    function WoodyResponse(response) {
        this.logger = new Logger(this.constructor.name);
        this.response = response;
        this.body = null;
    }
    WoodyResponse.prototype.JSON = function () {
        return __awaiter(this, void 0, void 0, function () {
            var body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.response.status === 204) {
                            // the body is empty
                            return [2 /*return*/, null];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.response.json()];
                    case 2:
                        body = _a.sent();
                        this.body = body;
                        return [2 /*return*/, this.body];
                    case 3:
                        _a.sent();
                        this.body = null;
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    WoodyResponse.prototype.Uint8Array = function () {
        return __awaiter(this, void 0, void 0, function () {
            var body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.response.status === 204) {
                            // the body is empty
                            return [2 /*return*/, null];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.response.arrayBuffer()];
                    case 2:
                        body = _a.sent();
                        this.body = new Uint8Array(body);
                        return [2 /*return*/, this.body];
                    case 3:
                        _a.sent();
                        this.body = null;
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(WoodyResponse.prototype, "error", {
        get: function () {
            var _a, _b, _c;
            // if we get a 2xx HTTP status code, it means
            // success and there is no error in the body
            if (is2xx(this.response.status)) {
                return null;
            }
            // else the body will follow this structure
            var err = {
                title: (_a = this.body) === null || _a === void 0 ? void 0 : _a.title,
                detail: (_b = this.body) === null || _b === void 0 ? void 0 : _b.detail,
                status: (_c = this.body) === null || _c === void 0 ? void 0 : _c.status,
            };
            return err;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WoodyResponse.prototype, "data", {
        get: function () {
            return this.body;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WoodyResponse.prototype, "headers", {
        get: function () {
            return Object.fromEntries(this.response.headers.entries());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WoodyResponse.prototype, "status", {
        get: function () {
            return this.response.status;
        },
        enumerable: false,
        configurable: true
    });
    return WoodyResponse;
}());

var Authentication;
(function (Authentication) {
    Authentication["REQUIRED"] = "required";
    Authentication["OPTIONAL"] = "optional";
    Authentication["NONE"] = "none";
})(Authentication || (Authentication = {}));
var WoodyRequest = /** @class */ (function () {
    function WoodyRequest(config) {
        var _a, _b;
        this.logger = new Logger(this.constructor.name);
        this.method = config.method;
        this.url = config.url;
        this.authentication = config.authentication;
        this.contentType = (_a = config.contentType) !== null && _a !== void 0 ? _a : 'application/json';
        this.requiresCSRF = config.requiresCSRF;
        this.headers = config.headers;
        this.query = config.query;
        this.body = config.body;
        this.rawBody = (_b = config.rawBody) !== null && _b !== void 0 ? _b : false;
        this.authenticator = config.authenticator;
        this.woodyClient = config.woodyClient;
    }
    WoodyRequest.prototype.send = function () {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var method, url, _i, _e, _f, k, v, headers, deviceInfo, headerMappings, _g, data, error, token, e_1, tokenIsValid, jwt, body, response, woodyResponse;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        method = this.method;
                        url = new URL(this.url);
                        // add query params
                        if (this.query) {
                            for (_i = 0, _e = Object.entries(this.query); _i < _e.length; _i++) {
                                _f = _e[_i], k = _f[0], v = _f[1];
                                if (v !== undefined && v !== null) {
                                    url.searchParams.append(k, v);
                                }
                            }
                        }
                        headers = (_a = this.headers) !== null && _a !== void 0 ? _a : {};
                        headers['Content-Type'] = this.contentType;
                        deviceInfo = (_b = this.woodyClient) === null || _b === void 0 ? void 0 : _b.getDeviceInfo();
                        if (deviceInfo && typeof deviceInfo === 'object') {
                            headerMappings = {
                                device: 'device',
                                appVersion: 'app-version',
                                webVersion: 'web-version',
                                orSessionId: 'or-sessionid',
                            };
                            Object.entries(headerMappings).forEach(function (_a) {
                                var key = _a[0], headerName = _a[1];
                                if (deviceInfo[key]) {
                                    headers[headerName] = deviceInfo[key];
                                }
                            });
                        }
                        if (!this.requiresCSRF) return [3 /*break*/, 2];
                        if (!this.woodyClient)
                            throw new Error('WoodyClient is required for CSRF protection');
                        return [4 /*yield*/, this.woodyClient.getCSRFToken()];
                    case 1:
                        _g = _h.sent(), data = _g.data, error = _g.error;
                        if (error)
                            throw new Error('Unable to get needed CSRF token.');
                        headers['X-CSRF-Token'] = data['csrf-token'];
                        _h.label = 2;
                    case 2:
                        token = null;
                        _h.label = 3;
                    case 3:
                        _h.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, ((_c = this.authenticator) === null || _c === void 0 ? void 0 : _c.getToken())];
                    case 4:
                        token = (_d = (_h.sent())) !== null && _d !== void 0 ? _d : null;
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _h.sent();
                        this.logger.error("error getting token: ".concat(e_1));
                        return [3 /*break*/, 6];
                    case 6:
                        tokenIsValid = (token && (token === null || token === void 0 ? void 0 : token.getExpiration()) * 1000 > Date.now()) ||
                            !this.authenticator;
                        // token is required but is invalid, can't continue
                        if (this.authentication === Authentication.REQUIRED && !tokenIsValid) {
                            this.logger.error("auth required for ".concat(this.url, " but token is invalid: ").concat(JSON.stringify(token)));
                            throw new Error('WoodyClient not authenticated');
                        }
                        // token should be added to the header
                        if ([Authentication.REQUIRED, Authentication.OPTIONAL].includes(this.authentication) &&
                            tokenIsValid &&
                            this.authenticator) {
                            jwt = token === null || token === void 0 ? void 0 : token.getJwtToken();
                            headers.Authorization = "Bearer ".concat(jwt);
                        }
                        body = this.rawBody
                            ? // If raw body it should only be Blob or string or Uint8Array
                                this.body instanceof Blob ||
                                    typeof this.body === 'string' ||
                                    this.body instanceof Uint8Array ||
                                    this.body instanceof File
                                    ? this.body
                                    : undefined
                            : // If not raw body it should be an object or undefined
                                this.body
                                    ? JSON.stringify(this.body)
                                    : undefined;
                        return [4 /*yield*/, fetch(url, {
                                method: method,
                                headers: headers,
                                body: body,
                                credentials: !this.authenticator ? 'include' : 'same-origin',
                            })];
                    case 7:
                        response = _h.sent();
                        woodyResponse = new WoodyResponse(response);
                        if (!(response.status >= 400)) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.woodyClient.trigger('error', {
                                type: 'error',
                                response: woodyResponse,
                            })];
                    case 8:
                        _h.sent();
                        _h.label = 9;
                    case 9:
                        if (!(response.status === 401)) return [3 /*break*/, 11];
                        return [4 /*yield*/, this.woodyClient.trigger('unauthorized', {
                                type: 'unauthorized',
                                response: woodyResponse,
                            })];
                    case 10:
                        _h.sent();
                        _h.label = 11;
                    case 11: return [2 /*return*/, woodyResponse];
                }
            });
        });
    };
    return WoodyRequest;
}());

/**
 * Factory for creating WoodyRequest objects and injecting
 * common dependencies into every request.
 */
var WoodyRequestFactory = /** @class */ (function () {
    function WoodyRequestFactory(client) {
        this.client = client;
    }
    WoodyRequestFactory.prototype.create = function (config) {
        return new WoodyRequest(__assign(__assign({}, config), { woodyClient: this.client }));
    };
    return WoodyRequestFactory;
}());

var transformQuery = function (query) {
    var result = (query && qs.stringify(query)) || '';
    return result;
};
var buildUri = function (apiUrl, url, query) {
    if (url === void 0) { url = ''; }
    var resUrl = url.startsWith('http')
        ? new URL(url)
        : new URL("".concat(apiUrl).concat(url));
    resUrl.search = (query && transformQuery(query)) || '';
    return resUrl.toString();
};
var transformBody = function (body) {
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
        return body;
    }
    if (!body) {
        return null;
    }
    if ((typeof FormData !== 'undefined' && body instanceof FormData) ||
        body instanceof ArrayBuffer ||
        body instanceof Blob) {
        return body;
    }
    return JSON.stringify(body);
};
var isNonJSONBody = function (body) {
    return ((typeof FormData !== 'undefined' && body instanceof FormData) ||
        body instanceof ArrayBuffer ||
        body instanceof Blob);
};
/**
 * GET example fetchApi('/pathname')
 * GET example with search query fetchApi('/pathname', { query: { limit: 10 } } )
 * POST example fetchApi('/pathname', { method: 'POST', body: { some: 'data' } } )
 *
 * if you ask for opt.pagination, make sure u send { limit, offset } in search query
 *
 *
 * @param {*} path
 * @param {*} initParam
 */
var fetchApi = function (url, initParam, opt) {
    if (initParam === void 0) { initParam = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var query, init, body, requestInit, apiAddress;
        return __generator(this, function (_a) {
            query = initParam.query, init = __rest(initParam, ["query"]);
            body = transformBody(init === null || init === void 0 ? void 0 : init.body);
            requestInit = __assign(__assign({ credentials: 'include' }, init), { 
                // body: JSON.stringify(init?.body),
                body: body, headers: __assign(__assign({ accept: 'application/json' }, init === null || init === void 0 ? void 0 : init.headers), (init.method && !isNonJSONBody(body)
                    ? {
                        'Content-type': 'application/json',
                    }
                    : {})) });
            apiAddress = buildUri(opt.apiUrl, url, query);
            return [2 /*return*/, fetch(apiAddress, requestInit).then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
                    var contentType, isChunked, result;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (!(res.status >= 200 && res.status < 300)) return [3 /*break*/, 2];
                                contentType = res.headers.get('content-type');
                                // if the returned type header is an octet stream, return the blob
                                if (contentType === 'application/octet-stream') {
                                    return [2 /*return*/, res.blob()];
                                }
                                isChunked = res.headers.get('Content-Length') === null &&
                                    res.body instanceof ReadableStream &&
                                    contentType !== 'application/json' &&
                                    contentType !== 'application/hal+json';
                                if (isChunked) {
                                    // return an object with a generator function that yields the chunks
                                    return [2 /*return*/, (_a = {},
                                            _a[Symbol.asyncIterator] = function () {
                                                var _a;
                                                return __asyncGenerator(this, arguments, function _b() {
                                                    var reader, _c, done, value;
                                                    return __generator(this, function (_d) {
                                                        switch (_d.label) {
                                                            case 0:
                                                                reader = (_a = res.body) === null || _a === void 0 ? void 0 : _a.getReader();
                                                                if (!!reader) return [3 /*break*/, 2];
                                                                return [4 /*yield*/, __await(void 0)];
                                                            case 1: return [2 /*return*/, _d.sent()];
                                                            case 2:
                                                                return [4 /*yield*/, __await(reader.read())];
                                                            case 3:
                                                                _c = _d.sent(), done = _c.done, value = _c.value;
                                                                if (!done) return [3 /*break*/, 5];
                                                                return [4 /*yield*/, __await(void 0)];
                                                            case 4: return [2 /*return*/, _d.sent()];
                                                            case 5: return [4 /*yield*/, __await(new TextDecoder().decode(value))];
                                                            case 6: return [4 /*yield*/, _d.sent()];
                                                            case 7:
                                                                _d.sent();
                                                                return [3 /*break*/, 2];
                                                            case 8: return [2 /*return*/];
                                                        }
                                                    });
                                                });
                                            },
                                            _a)];
                                }
                                return [4 /*yield*/, res.json().catch(function () {
                                        /** couldn't parse body, assume OK response with no body */
                                        return Promise.resolve();
                                    })];
                            case 1:
                                result = _b.sent();
                                return [2 /*return*/, result];
                            case 2: 
                            // SOME ERROR CODE
                            return [2 /*return*/, res
                                    .json()
                                    .catch(function () {
                                    return Promise.reject({
                                        status: res.status,
                                    });
                                })
                                    .then(function (json) {
                                    // const error = (json.error || json?.message) as ErrorType;
                                    return Promise.reject(__assign({ status: res.status }, json));
                                })];
                        }
                    });
                }); })];
        });
    });
};

var getParamValue = function (params, paramName) {
    var variableKey = paramName;
    if (!params[variableKey])
        throw Error("Param ".concat(paramName, " was not provided"));
    return params[variableKey];
};
/**
 *
 * @example
 * ```ts
 * generateApiPath(
 *  "/workspace/{workspaceId}/company/{companyId}",
 *  { workspaceId: 'my-ws', companyId: 'my-corp }
 * );
 * // "/workspace/my-ws/company/my-corp"
 */
function generateApiPath(_a) {
    var endpoint = _a.endpoint, params = _a.params;
    var regex = /[{](?<variable>\w+)[}]/g;
    return endpoint
        .toString()
        .replace(regex, function (_, key) { return getParamValue(params, key); });
}

var prepareFetchApi = function (apiUrl, woodyClient) {
    return function (endpoint, init) { return __awaiter(void 0, void 0, void 0, function () {
        var method, apiEndpointPath, headers, deviceInfo, headerMappings, csrf;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    method = init === null || init === void 0 ? void 0 : init.method;
                    apiEndpointPath = typeof endpoint === 'string' ? endpoint : generateApiPath(endpoint);
                    headers = {};
                    deviceInfo = woodyClient.getDeviceInfo();
                    if (deviceInfo && typeof deviceInfo === 'object') {
                        headerMappings = {
                            device: 'device',
                            appVersion: 'app-version',
                            webVersion: 'web-version',
                            orSessionId: 'or-sessionid',
                        };
                        Object.entries(headerMappings).forEach(function (_a) {
                            var key = _a[0], headerName = _a[1];
                            if (deviceInfo[key]) {
                                headers[headerName] = deviceInfo[key];
                            }
                        });
                    }
                    if (!(init === null || init === void 0 ? void 0 : init.requireCsrf)) return [3 /*break*/, 2];
                    return [4 /*yield*/, woodyClient.v2('/v2/csrf-token')];
                case 1:
                    csrf = _a.sent();
                    headers['X-CSRF-Token'] = csrf['csrf-token'];
                    _a.label = 2;
                case 2: return [4 /*yield*/, fetchApi(apiEndpointPath, __assign(__assign({}, init), { method: method ? String(method).toUpperCase() : undefined, headers: __assign(__assign({}, headers), init === null || init === void 0 ? void 0 : init.headers) }), {
                        apiUrl: apiUrl,
                    })];
                case 3: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
};

var WoodyClient = /** @class */ (function () {
    function WoodyClient(baseUrl, authenticator, logLevel, deviceInfo) {
        this.baseUrl = baseUrl;
        this.authenticator = authenticator;
        this.deviceInfo = deviceInfo;
        this.requestFactory = new WoodyRequestFactory(this);
        this.eventListeners = {};
        this.logger = new Logger(this.constructor.name, logLevel);
        this.v2 = prepareFetchApi(baseUrl, this);
    }
    /**
     * Sets the OR Session ID that we pass to the backend via headers.
     * The OR Session ID is not known at the time of creating the client,
     * so it can be set later here.
     *
     * @param orSessionId - The OR Session ID to set
     */
    WoodyClient.prototype.setOrSessionId = function (orSessionId) {
        this.deviceInfo = this.deviceInfo || {};
        this.deviceInfo.orSessionId = orSessionId || undefined;
    };
    /**
     * Sets the App Version that we pass to the backend via headers.
     * The App Version for mobile is asynchronusly fetched from the native code
     * so it needs to be set later here.
     *
     * @param appVersion - The App Version to set
     */
    WoodyClient.prototype.setAppVersion = function (appVersion) {
        this.deviceInfo = this.deviceInfo || {};
        this.deviceInfo.appVersion = appVersion || undefined;
    };
    WoodyClient.prototype.getDeviceInfo = function () {
        return this.deviceInfo;
    };
    /**
     * @deprecated
     */
    WoodyClient.prototype.fetchHome = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/"),
                            contentType: 'application/json',
                            body: undefined,
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated use fetchOwnUserInfo instead if trying to get the user's own info
     */
    WoodyClient.prototype.fetchUserById = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/users/").concat(id),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.fetchOwnUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/userinfo"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Get the link preview for a webnote.
     */
    WoodyClient.prototype.fetchLinkPreview = function (resourceId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/resources/").concat(resourceId, "/preview"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Fetch a list by id.
     */
    WoodyClient.prototype.fetchListById = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/lists/").concat(id),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.fetchFolderSummmary = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/folders/").concat(id, "/summary"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Fetch the list memberships for a given user.
     * i.e. all the lists that the user is a member of.
     */
    WoodyClient.prototype.fetchMembershipsByUserId = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/users/").concat(userId, "/list-memberships"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Fetch the list memberships for a given list.
     * i.e. all the users that are members of the list.
     */
    WoodyClient.prototype.fetchMembershipsByListId = function (listId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/lists/").concat(listId, "/members"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated use completeOnboardingStep instead
     * Mark the onboarding process as completed for a given user.
     */
    WoodyClient.prototype.markOnboardingCompleted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'PUT',
                            url: "".concat(this.baseUrl, "/onboard"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.completeOnboardingStep = function (step) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'PUT',
                            url: "".concat(this.baseUrl, "/onboarding/").concat(step),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Get fdocs belonging to a given list.
     */
    WoodyClient.prototype.fetchFdocsByListId = function (listId, pagination) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/lists/").concat(listId, "/fdocs"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            query: __assign({}, pagination),
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Create a new list.
     */
    WoodyClient.prototype.postNewList = function (userId, newList) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/users/").concat(userId, "/lists"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: newList,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Update a list.
     */
    WoodyClient.prototype.putList = function (listId, newList) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'PUT',
                            url: "".concat(this.baseUrl, "/lists/").concat(listId),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: newList,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Delete a list.
     */
    WoodyClient.prototype.deleteList = function (listId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'DELETE',
                            url: "".concat(this.baseUrl, "/lists/").concat(listId),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Add user as member of a list with the specific role.
     */
    WoodyClient.prototype.joinList = function (listId, userId, role) {
        if (role === void 0) { role = 'reader'; }
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/lists/").concat(listId, "/members"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                userId: userId,
                                role: role,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Remove a user as member of list.
     */
    WoodyClient.prototype.leaveList = function (listId, userId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'DELETE',
                            url: "".concat(this.baseUrl, "/lists/").concat(listId, "/members/").concat(userId),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: undefined,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Returns all fdocs  that a user created or has access to.
     * Should only be used for the extension.
     */
    WoodyClient.prototype.fetchNotes = function (pagination, filters) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/notes"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            query: __assign(__assign({}, pagination), filters),
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Return all fdocs that user has access to and match query.
     */
    WoodyClient.prototype.search = function (pagination, filters) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/fdocs"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            query: __assign(__assign({}, pagination), filters),
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * TODO: refactor image API to align with fdoc rather than notes
     *
     * Upload an image.
     */
    WoodyClient.prototype.uploadImage = function (fdocId, blob) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'PUT',
                            url: "".concat(this.baseUrl, "/notes/").concat(fdocId, "/image"),
                            contentType: 'image/png',
                            authenticator: this.authenticator,
                            body: blob,
                            rawBody: true,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated use V2 API instead
     *
     * Create a new comment.
     */
    WoodyClient.prototype.postNewComment = function (resourceId, content) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/resources/").concat(resourceId, "/comments"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                content: content,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated use V2 API instead
     *
     * Update an existing comment.
     */
    WoodyClient.prototype.updateComment = function (resourceId, commentId, content) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'PUT',
                            url: "".concat(this.baseUrl, "/resources/").concat(resourceId, "/comments/").concat(commentId),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                content: content,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Update an existing notepad.
     */
    WoodyClient.prototype.updateNotepad = function (notepadId, title, content, editorjs) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'PUT',
                            url: "".concat(this.baseUrl, "/notepads/").concat(notepadId),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                title: title,
                                content: content || null,
                                editorjs: editorjs || null,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated use V2 API instead
     *
     * Delete a comment
     */
    WoodyClient.prototype.deleteComment = function (fdocId, commentId, listId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.baseUrl;
                        if (listId) {
                            url += "/lists/".concat(listId, "/fdocs/").concat(fdocId, "/comments/").concat(commentId);
                        }
                        else {
                            url += "/fdocs/".concat(fdocId, "/comments/").concat(commentId);
                        }
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'DELETE',
                            url: url,
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated use V2 API instead
     *
     * Get the comments on a given note
     */
    WoodyClient.prototype.fetchComments = function (resourceId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/resources/").concat(resourceId, "/comments"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Get the image for a given image note
     */
    WoodyClient.prototype.fetchImage = function (noteId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/notes/").concat(noteId, "/image"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Request S3 presigned POST data that can be used
     * to upload a file directly to S3.
     *
     * Optional filename.
     */
    WoodyClient.prototype.getPresignedPost = function (filename) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/upload"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            query: filename ? { filename: filename } : undefined,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Request presigned POST data that can be used
     * to upload a file to be embedded into a notepad.
     *
     * Returns a presigned post and the location URL of the file after upload.
     */
    WoodyClient.prototype.getPresignedPostForNotepad = function (notepadId, filename) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/notepads/").concat(notepadId, "/presigned-upload"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                filename: filename,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Upload a file through an R3 signed PUT.
     * @param presignedPost The presigned post data
     * @param file The file to upload
     * @param onProgessUpdate A callback to be called on progress update, if available
     * @param signal An abort signal to abort the upload mid-way
     * @returns A promise that resolves to the key of the uploaded file
     */
    WoodyClient.prototype.uploadFileR2 = function (presignedPost, file, onProgessUpdate, signal) {
        return __awaiter(this, void 0, void 0, function () {
            var presignedPostFixed, urlObj, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        presignedPostFixed = {
                            url: presignedPost.url,
                            headers: {},
                        };
                        if (presignedPost.headers) {
                            presignedPostFixed.headers = Object.fromEntries(Object.entries(presignedPost.headers).filter(function (_a) {
                                var value = _a[1];
                                return value !== undefined;
                            }));
                        }
                        if (!(typeof XMLHttpRequest !== 'undefined')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.uploadFileR2WithXHR(presignedPostFixed, file, onProgessUpdate, signal)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.uploadFileR2WithFetch(presignedPostFixed, file, signal)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        urlObj = new URL(presignedPost.url);
                        key = decodeURIComponent(urlObj.pathname.slice(1));
                        // we replace ${filename} in the S3 key with the filename,
                        // to have the actual key of the object.
                        // note that ${filename} is a special value in presigned url on S3
                        // that get automatically replaced with the filename once uploaded
                        // eslint-disable-next-line no-template-curly-in-string
                        return [2 /*return*/, key];
                }
            });
        });
    };
    WoodyClient.prototype.sanitizeForUrlParam = function (input) {
        var sanitizedString = input.replace(/[^a-zA-Z0-9\-_]/g, '-');
        return sanitizedString.replace(/[-_]{2,}/g, '-');
    };
    /**
     * Uploads a file using the XMLHttpRequest (XHR) method.
     * This function is utilized when XHR is available in the environment.
     * It is considered the preferred method since it provides progress updates.
     * @param presignedPost The presigned post data for the S3 bucket
     * @param file The file to upload
     * @param onProgessUpdate Callback to provide progress updates (if XHR is available)
     * @param signal An abort signal to terminate the upload process
     * @returns A promise that resolves when the upload completes or throws an error if the upload fails
     */
    WoodyClient.prototype.uploadFileR2WithXHR = function (presignedPost, file, onProgessUpdate, signal) {
        return __awaiter(this, void 0, void 0, function () {
            var xhr, data, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        xhr = new XMLHttpRequest();
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                // If an abort signal is provided, setup an abort event listener.
                                if (signal) {
                                    signal.addEventListener('abort', function () {
                                        xhr.abort();
                                    });
                                }
                                // If a progress update callback is provided, setup a progress event listener.
                                if (onProgessUpdate) {
                                    xhr.upload.addEventListener('progress', onProgessUpdate);
                                }
                                // Listen for the load and error events to resolve or reject the promise.
                                xhr.addEventListener('load', function () {
                                    resolve({
                                        status: xhr.status,
                                        response: xhr.response,
                                    });
                                });
                                xhr.addEventListener('error', function () {
                                    reject(new Error('failed to upload'));
                                });
                                // Initiate the request.
                                xhr.open('PUT', presignedPost.url, true);
                                // Set headers
                                if (presignedPost.headers) {
                                    Object.entries(presignedPost.headers).forEach(function (_a) {
                                        var key = _a[0], value = _a[1];
                                        xhr.setRequestHeader(key, value);
                                    });
                                }
                                // Send the file.
                                xhr.send(file);
                            })];
                    case 1:
                        data = _a.sent();
                        if (!!is2xx(data.status)) return [3 /*break*/, 3];
                        return [4 /*yield*/, data.response.text()];
                    case 2:
                        error = _a.sent();
                        console.error('R2 error', error);
                        throw new Error('failed to upload');
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Uploads a file using the Fetch API method.
     * This function acts as a fallback when XMLHttpRequest (XHR) is not available.
     * @param presignedPost The presigned post data for the S3 bucket
     * @param file The file to upload
     * @param signal An abort signal to terminate the upload process
     * @returns A promise that resolves when the upload completes or throws an error if the upload fails
     */
    WoodyClient.prototype.uploadFileR2WithFetch = function (presignedPost, file, signal) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, fetch(presignedPost.url, {
                                method: 'PUT',
                                body: file,
                                headers: presignedPost.headers,
                                signal: signal,
                            })];
                    case 1:
                        response = _a.sent();
                        if (!!is2xx(response.status)) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.text()];
                    case 2:
                        error = _a.sent();
                        console.error('R2 error', error);
                        throw new Error('failed to upload');
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        if (e_1.name === 'AbortError') {
                            throw e_1;
                        }
                        throw new Error('failed to upload');
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get the stored-file.
     */
    WoodyClient.prototype.fetchStoredFile = function (storedFileId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/stored-files/").concat(storedFileId),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Get all notifications for a specific user, sorted by createdAt in DESC order.
     */
    WoodyClient.prototype.getNotifications = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/users/").concat(userId, "/notifications"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Mark a notification as read.
     */
    WoodyClient.prototype.markNotificationAsRead = function (userId, notificationId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'PUT',
                            url: "".concat(this.baseUrl, "/users/").concat(userId, "/notifications/").concat(notificationId),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Get notification stats for a user, such as total and unread notification counts.
     */
    WoodyClient.prototype.getNotificationStats = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/users/").concat(userId, "/notifications/stats"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.login = function (email, password, inviteToken) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.NONE,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/auth/login"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                email: email,
                                password: password,
                                inviteToken: inviteToken,
                            },
                            requiresCSRF: true,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.logout = function (refreshToken) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/auth/logout"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: refreshToken
                                ? {
                                    refreshToken: refreshToken,
                                }
                                : undefined,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated - use V2 API instead
     */
    WoodyClient.prototype.signup = function (_a) {
        var email = _a.email, password = _a.password, name = _a.name, inviteToken = _a.inviteToken, recaptcha = _a.recaptcha, timezone = _a.timezone;
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.NONE,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/auth/signup"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                email: email,
                                password: password,
                                name: name,
                                inviteToken: inviteToken,
                                recaptcha: recaptcha,
                                timezone: timezone,
                            },
                            requiresCSRF: true,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _b.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated - use V2 API instead
     */
    WoodyClient.prototype.confirmSignup = function (email, confirmationCode) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.NONE,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/auth/signup/confirm"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                email: email,
                                confirmationCode: confirmationCode,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated - use V2 API instead
     */
    WoodyClient.prototype.resendSignupConfirmationCode = function (email, recaptcha) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.NONE,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/auth/signup/resend-confirm"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                email: email,
                                recaptcha: recaptcha,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.refreshToken = function (refreshToken) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.NONE,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/auth/refresh"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                refreshToken: refreshToken,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.getGoogleOAuthUrl = function (redirectUri, inviteToken) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.NONE,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/oauth/google"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            query: {
                                redirectUri: redirectUri,
                                inviteToken: inviteToken,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     *
     * @param code
     * @param redirectUri should be the same as when calling getGoogleOAuthUrl
     * @returns
     */
    WoodyClient.prototype.exchangeOAuthCode = function (code, redirectUri, state) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.NONE,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/oauth/google/callback"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                code: code,
                                redirectUri: redirectUri,
                                state: state,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated use fetchOwnUserInfo instead
     */
    WoodyClient.prototype.getUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/auth/userinfo"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.forgotPassword = function (email, recaptcha) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.NONE,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/auth/forgot"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                email: email,
                                recaptcha: recaptcha,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.confirmForgotPassword = function (email, confirmationCode, newPassword) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.NONE,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/auth/forgot/confirm"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                email: email,
                                confirmationCode: confirmationCode,
                                password: newPassword,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Set a label on an FDoc in a List.
     */
    WoodyClient.prototype.setListFdocColorLabel = function (listId, resourceId, labelId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'PUT',
                            url: "".concat(this.baseUrl, "/lists/").concat(listId, "/resources/").concat(resourceId, "/label"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                labelId: labelId,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Get a user-specific Algolia API key allowing
     * user to query algolia for allowed documents.
     */
    WoodyClient.prototype.getAlgoliaApiKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/auth/algolia"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Get a list-specific Algolia API key allowing
     * user to query a specific public list (list that is being shared).
     */
    WoodyClient.prototype.getAlgoliaApiKeyForPublicList = function (listId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/auth/algolia"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            query: {
                                listId: listId,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Get a user-specific Typesense API key allowing
     * user to query Typesense for allowed documents.
     */
    WoodyClient.prototype.getTypesenseUserApiKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/auth/typesense"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Get a list-specific Typesense API key allowing
     * user to query a specific public list (list that is being shared).
     */
    WoodyClient.prototype.getTypesenseApiKeyForPublicList = function (listId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/auth/typesense"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            query: {
                                listId: listId,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Get a list-specific Typesense API key allowing
     * user to access a direct share of a resource.
     */
    WoodyClient.prototype.getTypesenseApiKeyForDirectShare = function (directShareSecret) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/auth/typesense"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            query: {
                                directShareSecret: directShareSecret,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    // update the user own information such as name
    WoodyClient.prototype.updateUserInfo = function (newUserInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'PUT',
                            url: "".concat(this.baseUrl, "/userinfo"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                name: newUserInfo.name,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.getStripeCheckoutSessionUrl = function (planId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/stripe/checkout"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                planId: planId,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data.url,
                            }];
                }
            });
        });
    };
    /**
     * The endpoint responds with status != 200 if the change fails.
     * Note downgrades are not allowed. Only upgrades.
     *
     * @param newPriceId The price id to change to
     * @returns success: true if the subscription was changed successfully
     */
    WoodyClient.prototype.changeSubscription = function (newPriceId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/subscriptions/change"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                priceId: newPriceId,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Cancels the subscription at the end of the current billing period.
     *
     * @returns success: true if the subscription was cancelled successfully
     */
    WoodyClient.prototype.cancelSubscription = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/subscriptions/cancel"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.getStripePortalSessionUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/stripe/portal"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data.url,
                            }];
                }
            });
        });
    };
    /**
     *
     * @param folderId the folder to create the resource into (if folder is part of a space, the resource will be created in the space)
     * @param resource the resource to create
     * @returns the created resource
     */
    WoodyClient.prototype.createResource = function (resource) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/folders/").concat(resource.parentResourceId, "/resources"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: __assign({}, resource),
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     *
     * @param resourceId the webnoteId which the image will be associated with
     * @param blob the image to be associated with the webnote
     * @returns success: true if the image was asscoiated with the screenshot successfully
     */
    WoodyClient.prototype.putWebnoteScreenshot = function (resourceId, blob) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'PUT',
                            url: "".concat(this.baseUrl, "/webnotes/").concat(resourceId, "/screenshot"),
                            contentType: 'image/png',
                            authenticator: this.authenticator,
                            body: blob,
                            rawBody: true,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     *
     * @param resourceId - the webnoteId for which you want to fetch the screenshot for (if it exists)
     * @returns { url: string } if the screenshot exists, and the string is a presigned url for the image. null if it doesn't exist
     */
    WoodyClient.prototype.getWebnoteScreenshot = function (resourceId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/webnotes/").concat(resourceId, "/screenshot"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Returns the resource with the given id
     * @param id the id of the resource to get
     * @returns the resource
     */
    WoodyClient.prototype.getResource = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/resources/").concat(id),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.moveResources = function (resourceIds, newParentId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'PUT',
                            url: "".concat(this.baseUrl, "/resources/move"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                resourceIds: resourceIds,
                                newParentId: newParentId,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.renameResource = function (resourceId, newName) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'PUT',
                            url: "".concat(this.baseUrl, "/resources/").concat(resourceId, "/rename"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                name: newName,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.deleteResources = function (resourceIds) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'DELETE',
                            url: "".concat(this.baseUrl, "/resources/delete"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                resourceIds: resourceIds,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.shareResource = function (resourceId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'PUT',
                            url: "".concat(this.baseUrl, "/resources/").concat(resourceId, "/share"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.unshareResource = function (resourceId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'PUT',
                            url: "".concat(this.baseUrl, "/resources/").concat(resourceId, "/unshare"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.getSharedResource = function (secret) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/share/").concat(secret),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Send a message to the chatbot and get a response as a stream.
     *
     * @param history The chat history
     * @param resourceId An optional resourceId if the chatbot should be resource-specific
     * @param ancestorId An optional ancestorId if the chatbot should be ancestor-specific
     * @param experimental An optional flag to enable experimental features
     */
    WoodyClient.prototype.streamAssistantAnswer = function (history, resourceId, ancestorId, experimental) {
        return __asyncGenerator(this, arguments, function streamAssistantAnswer_1() {
            var queryParams, serializedQuery, response, errorData, code, reader, decoder, buffer, _a, done, value, strValue, newlineIndex, line, decodedToken;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        queryParams = new URLSearchParams();
                        if (experimental) {
                            queryParams.set('experimental', 'true');
                        }
                        serializedQuery = queryParams.toString()
                            ? "?".concat(queryParams.toString())
                            : '';
                        return [4 /*yield*/, __await(fetch("".concat(this.baseUrl, "/chat").concat(serializedQuery), {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    history: history,
                                    resourceId: resourceId,
                                    ancestorId: ancestorId,
                                }),
                                credentials: 'include',
                            }))];
                    case 1:
                        response = _b.sent();
                        if (!!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, __await(response.json())];
                    case 2:
                        errorData = _b.sent();
                        code = errorData.code;
                        console.error('error streaming', errorData);
                        throw new Error(code);
                    case 3:
                        reader = response.body.getReader();
                        decoder = new TextDecoder();
                        buffer = '';
                        _b.label = 4;
                    case 4:
                        return [4 /*yield*/, __await(reader.read())];
                    case 5:
                        _a = _b.sent(), done = _a.done, value = _a.value;
                        if (done) {
                            return [3 /*break*/, 10];
                        }
                        strValue = decoder.decode(value);
                        buffer += strValue;
                        newlineIndex = void 0;
                        _b.label = 6;
                    case 6:
                        if (!((newlineIndex = buffer.indexOf('\n')) !== -1)) return [3 /*break*/, 9];
                        line = buffer.slice(0, newlineIndex);
                        buffer = buffer.slice(newlineIndex + 1);
                        decodedToken = decodeURI(line);
                        return [4 /*yield*/, __await(decodedToken)];
                    case 7: return [4 /*yield*/, _b.sent()];
                    case 8:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 9: return [3 /*break*/, 4];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    WoodyClient.prototype.searchV2 = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/search"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: query,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.searchV2Get = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var params, filterKey, filterVal, request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            mode: query.mode,
                        };
                        if ('text' in query) {
                            params['text'] = query.text;
                        }
                        if ('item' in query) {
                            params['item'] = query.item;
                        }
                        if (query.pagination) {
                            params['page'] = query.pagination.page;
                            params['pageSize'] = query.pagination.pageSize;
                        }
                        if (query.sort) {
                            params['sortField'] = query.sort.field;
                            params['sortOrder'] = query.sort.order;
                        }
                        if (query.filters) {
                            for (filterKey in query.filters) {
                                filterVal = query.filters[filterKey];
                                if (Array.isArray(filterVal)) {
                                    filterVal = filterVal.join(',');
                                }
                                else if (typeof filterVal === 'boolean') {
                                    filterVal = filterVal ? 'true' : 'false';
                                }
                                params[filterKey] = filterVal;
                            }
                        }
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/search"),
                            authenticator: this.authenticator,
                            query: params,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.searchV2AsGuest = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/search/guest"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: query,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.searchV2AsGuestGet = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var params, filterKey, filterVal, request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            mode: query.mode,
                        };
                        if ('text' in query) {
                            params['text'] = query.text;
                        }
                        if ('item' in query) {
                            params['item'] = query.item;
                        }
                        if (query.pagination) {
                            params['page'] = query.pagination.page;
                            params['pageSize'] = query.pagination.pageSize;
                        }
                        if (query.sort) {
                            params['sortField'] = query.sort.field;
                            params['sortOrder'] = query.sort.order;
                        }
                        if (query.filters) {
                            for (filterKey in query.filters) {
                                filterVal = query.filters[filterKey];
                                if (Array.isArray(filterVal)) {
                                    filterVal = filterVal.join(',');
                                }
                                else if (typeof filterVal === 'boolean') {
                                    filterVal = filterVal ? 'true' : 'false';
                                }
                                params[filterKey] = filterVal;
                            }
                        }
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/search/guest"),
                            authenticator: this.authenticator,
                            query: params,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    // set a referral code on the user
    WoodyClient.prototype.setReferral = function (referralCode) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'PUT',
                            url: "".concat(this.baseUrl, "/users/referral"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                referral: referralCode,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.getUsage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response, _i, _a, _b, key, value;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/usage"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _c.sent();
                        for (_i = 0, _a = Object.entries(response.data); _i < _a.length; _i++) {
                            _b = _a[_i], key = _b[0], value = _b[1];
                            if (value === null) {
                                response.data[key] = Infinity;
                            }
                        }
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.getChatbotUsage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response, _i, _a, _b, key, value;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/chat/usage"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _c.sent();
                        for (_i = 0, _a = Object.entries(response.data); _i < _a.length; _i++) {
                            _b = _a[_i], key = _b[0], value = _b[1];
                            if (value === null) {
                                response.data[key] = Infinity;
                            }
                        }
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Create a session that can be claimed. This is useful for creating a session
     * on one frontend client and claiming it on another.
     *
     * @returns token to be used to claim a session in claimSession
     */
    WoodyClient.prototype.createClaimableSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/auth/token"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Claim a session created by createClaimableSession
     *
     * @param token the token returned by createClaimableSession
     * @returns nothing but sets the session cookie
     *
     */
    WoodyClient.prototype.claimSession = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.NONE,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/auth/token/claim"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                token: token,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Deletes all sessions associated with the logged in user
     *
     * @returns nothing
     *
     */
    WoodyClient.prototype.terminateSessions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/auth/terminate-sessions"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: undefined,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Filter resources for a user.
     */
    WoodyClient.prototype.filterResources = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var filters, pagination, sort, request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filters = query.filters;
                        pagination = {};
                        if (query.pagination) {
                            pagination = {
                                cursor: query.pagination.cursor,
                                pageSize: query.pagination.pageSize,
                            };
                        }
                        sort = {};
                        if (query.sort) {
                            sort = {
                                sortField: query.sort.field,
                                sortOrder: query.sort.order,
                            };
                        }
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/resources/filter"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: __assign(__assign(__assign({}, filters), pagination), sort),
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Will return a spotify preview data for embed cards
     * @param url
     * @returns wrapped link preview (or null inside the envelope)
     */
    WoodyClient.prototype.getSpotifyPreview = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/preview/spotify"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            query: {
                                url: encodeURIComponent(url),
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Will return a link preview (by URL)
     * @param url
     * @returns wrapped link preview (or null inside the envelope)
     */
    WoodyClient.prototype.getLinkPreview = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/preview/link"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            query: {
                                url: encodeURIComponent(url),
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * This endpoint should be called to render the main dashboard trees that the user owns.
     *
     * @returns the user's tree roots
     */
    WoodyClient.prototype.getUserResourceRoots = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/roots"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.renameColorLabelForList = function (listId, labelId, newName) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'PATCH',
                            url: "".concat(this.baseUrl, "/lists/").concat(listId, "/labels/").concat(labelId),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                name: newName,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Will set the YDoc state for a notepad using the provided binary state.
     * @param notepadId
     * @param yjsState
     */
    WoodyClient.prototype.setYDocState = function (notepadId, yjsState) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'PUT',
                            url: "".concat(this.baseUrl, "/notepads/").concat(notepadId, "/ydoc"),
                            contentType: 'application/octet-stream',
                            authenticator: this.authenticator,
                            body: yjsState,
                            rawBody: true,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: null,
                            }];
                }
            });
        });
    };
    /**
     * Will return the YDoc state for a notepad.
     * @param notepadId
     * @param yjsState
     * @returns the YDoc state
     */
    WoodyClient.prototype.getYDocState = function (notepadId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/notepads/").concat(notepadId, "/ydoc"),
                            contentType: 'application/octet-stream',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.Uint8Array()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * This endpoint returns the version of the server and the
     * minimum client version that is required to use the server.
     *
     * @returns the version info
     */
    WoodyClient.prototype.getVersionInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/version"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * This endpoint returns an announcement (if any) that should be shown to the user.
     *
     * @returns the announcement
     */
    WoodyClient.prototype.getAnnouncement = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/announcement"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.getGoogleDriveAuthorizationUrl = function (redirectUri) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/integrations/google-drive/oauth/authorize"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                redirectUri: redirectUri,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.exchangeGoogleOAuthCode = function (code, state) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/integrations/google-drive/oauth/callback"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            query: {
                                code: code,
                                state: state,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.getGoogleAccountCredentials = function (accountId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/integrations/google-drive/accounts/").concat(accountId, "/credentials"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.getGoogleAccounts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/integrations/google-drive/accounts"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.createGoogleDriveMirror = function (accountId, driveId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/integrations/google-drive/accounts/").concat(accountId, "/mirrors"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                driveId: driveId,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.deleteGoogleDriveMirror = function (listId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'DELETE',
                            url: "".concat(this.baseUrl, "/integrations/google-drive/mirrors/").concat(listId),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.getGoogleDriveMirror = function (listId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/integrations/google-drive/mirrors/").concat(listId),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Returns a CSRF token for the current user.
     * @returns the CSRF token
     */
    WoodyClient.prototype.getCSRFToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/v2/csrf-token"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Retrieves a multiplayer session.
     * @param multiplayer session request
     * @returns Multiplayer Session
     */
    WoodyClient.prototype.getMultiplayerSession = function (sessionRequest) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/multiplayer/session"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: sessionRequest,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * This is the first step of a two-step process to change the user's email.
     *
     * @param newEmail The email to change to
     * @returns nothing
     */
    WoodyClient.prototype.requestEmailChange = function (newEmail) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/auth/change-email"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                email: newEmail,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * This is the second step of a two-step process to change the user's email.
     * Upon successful completion, the user's email will be changed and all
     * sessions for the underlying user will be invalidated.
     *
     * @param token The token contained in the email sent to the new email address
     * @returns nothing
     */
    WoodyClient.prototype.confirmEmailChange = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.OPTIONAL,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/auth/change-email/confirm"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            query: {
                                token: token,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Delete the user's account. This will delete all data associated with the user.
     *
     * @returns nothing
     */
    WoodyClient.prototype.deleteUserAccount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/auth/delete"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated - use V2 API
     *
     * Get the user's private tags. These tags are only visible to the user.
     *
     * @param q The query to filter tags by name prefix
     * @returns The user's private tags
     */
    WoodyClient.prototype.getOwnPrivateTags = function (q) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/tags"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            query: {
                                q: q,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated - use V2 API
     *
     * Create a new private tag for the user. The tag will be created with the
     * given name and associated with the given resource ID if a resource ID is
     * provided.
     *
     * If a tag with the given name already exists, the existing tag will be
     * returned.
     *
     * @param name The name of the new tag
     * @param resourceId The resource ID to associate with the new tag (optional)
     * @returns The new private tag
     */
    WoodyClient.prototype.createNewPrivateTag = function (name, resourceId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/tags"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                name: name,
                                resourceId: resourceId,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated - use V2 API
     *
     * Get a private tag by its ID.
     *
     * @param tagId The ID of the tag to get
     * @returns The private tag
     */
    WoodyClient.prototype.getPrivateTag = function (tagId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/tags/").concat(tagId),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated - use V2 API
     *
     * Rename a private tag. If a tag with the new name already exists, the server
     * will return a 4xx error.
     *
     * @param tagId The ID of the tag to rename
     * @param newName The new name for the tag
     * @returns The updated private tag
     */
    WoodyClient.prototype.renamePrivateTag = function (tagId, newName) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'PUT',
                            url: "".concat(this.baseUrl, "/tags/").concat(tagId),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                name: newName,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated - use V2 API
     *
     * Delete a private tag. It will be removed from all resources it is associated
     * with.
     *
     * @param tagId The ID of the tag to delete
     * @returns null
     */
    WoodyClient.prototype.deletePrivateTag = function (tagId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'DELETE',
                            url: "".concat(this.baseUrl, "/tags/").concat(tagId),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated - use V2 API
     *
     * Get a map of resource IDs to the private tags associated with them.
     * If a resource ID is not associated with any tags, it will have an empty array.
     *
     * @param resourceIds The ID of the resources to get tags for
     * @returns The private tags associated with the resource
     */
    WoodyClient.prototype.getPrivateTagsForResources = function (resourceIds) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/resources/tags"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                resourceIds: resourceIds,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated - use V2 API
     *
     * Add a private tag to a resource. Resources that are already associated with
     * the tag will not be duplicated.
     *
     * @param tagId The ID of the tag to add to the resources
     * @param resourceIds The IDs of the resources to add the tag to
     * @returns null
     */
    WoodyClient.prototype.addPrivateTagToResources = function (tagId, resourceIds) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/tags/resources"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                tagId: tagId,
                                resourceIds: resourceIds,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated - use V2 API
     *
     * Remove a private tag from a resource. If the tag is not associated with the
     * resource, the server will not return an error.
     *
     * @param tagId The ID of the tag to remove from the resources
     * @param resourceIds The IDs of the resources to remove the tag from
     * @returns null
     */
    WoodyClient.prototype.removePrivateTagFromResources = function (tagId, resourceIds) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'DELETE',
                            url: "".concat(this.baseUrl, "/tags/resources"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: {
                                tagId: tagId,
                                resourceIds: resourceIds,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     *
     * @param file a .html file containing bookmarks, generated by pocket
     * @returns BulkResourceImport: object containing the number of objects imported and the
     * resource Id of the folder they were uploaded to
     */
    WoodyClient.prototype.importPocketExport = function (file, filename) {
        return __awaiter(this, void 0, void 0, function () {
            var cleanFilename, request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cleanFilename = this.sanitizeForUrlParam(filename);
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/imports/pocket/bulk-upload/").concat(cleanFilename),
                            contentType: 'text/html',
                            authenticator: this.authenticator,
                            body: file,
                            rawBody: true,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     *
     * @param file a .html or .csv file containing bookmarks, generated by raindrop
     * @returns BulkResourceImport: object containing the number of objects imported and the
     * resource Id of the folder they were uploaded to
     */
    WoodyClient.prototype.importRaindropExport = function (file, filename) {
        return __awaiter(this, void 0, void 0, function () {
            var cleanFilename, request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cleanFilename = this.sanitizeForUrlParam(filename);
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/imports/raindrop/bulk-upload/").concat(cleanFilename),
                            contentType: 'text/html',
                            authenticator: this.authenticator,
                            body: file,
                            rawBody: true,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     *
     * @param file a .html or .csv file containing bookmarks, generated by chrome
     * @returns BulkResourceImport: object containing the number of objects imported and the
     * resource Id of the folder they were uploaded to
     */
    WoodyClient.prototype.importChromeExport = function (file, filename) {
        return __awaiter(this, void 0, void 0, function () {
            var cleanFilename, request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cleanFilename = this.sanitizeForUrlParam(filename);
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/imports/chrome/bulk-upload/").concat(cleanFilename),
                            contentType: 'text/html',
                            authenticator: this.authenticator,
                            body: file,
                            rawBody: true,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     *
     * @param file a .html or .csv file containing bookmarks, generated by safari
     * @returns BulkResourceImport: object containing the number of objects imported and the
     * resource Id of the folder they were uploaded to
     */
    WoodyClient.prototype.importSafariExport = function (file, filename) {
        return __awaiter(this, void 0, void 0, function () {
            var cleanFilename, request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cleanFilename = this.sanitizeForUrlParam(filename);
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/imports/safari/bulk-upload/").concat(cleanFilename),
                            contentType: 'text/html',
                            authenticator: this.authenticator,
                            body: file,
                            rawBody: true,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     *
     * @param file a .html or .csv file containing bookmarks, generated by firefox
     * @returns BulkResourceImport: object containing the number of objects imported and the
     * resource Id of the folder they were uploaded to
     */
    WoodyClient.prototype.importFirefoxExport = function (file, filename) {
        return __awaiter(this, void 0, void 0, function () {
            var cleanFilename, request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cleanFilename = this.sanitizeForUrlParam(filename);
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/imports/firefox/bulk-upload/").concat(cleanFilename),
                            contentType: 'text/html',
                            authenticator: this.authenticator,
                            body: file,
                            rawBody: true,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     *
     * @param file a .html or .csv file containing bookmarks, generated by edge
     * @returns BulkResourceImport: object containing the number of objects imported and the
     * resource Id of the folder they were uploaded to
     */
    WoodyClient.prototype.importEdgeExport = function (file, filename) {
        return __awaiter(this, void 0, void 0, function () {
            var cleanFilename, request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cleanFilename = this.sanitizeForUrlParam(filename);
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/imports/edge/bulk-upload/").concat(cleanFilename),
                            contentType: 'text/html',
                            authenticator: this.authenticator,
                            body: file,
                            rawBody: true,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     *
     * @returns BulkResourceImports: an array of objects containing information about the resource imports
     * that a user has done
     */
    WoodyClient.prototype.getResourceImportsForUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/imports/resource-imports"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     *
     * @returns { searches: string[] } an array of strings that show the user's 10 most recent searches in descending recency
     */
    WoodyClient.prototype.getRecentSearches = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/search/saved/recent"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     *
     * @returns success: true if the search was deleted for that user
     */
    WoodyClient.prototype.deleteRecentSearch = function (searchValue) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'DELETE',
                            url: "".concat(this.baseUrl, "/search/saved/recent"),
                            contentType: 'application/json',
                            body: {
                                searchValue: searchValue,
                            },
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     *
     * @returns success: true if all the user's saved searches were deleted
     */
    WoodyClient.prototype.deleteAllSavedSearchesForUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'DELETE',
                            url: "".concat(this.baseUrl, "/search/saved/recent"),
                            contentType: 'application/json',
                            body: {
                                deleteAll: true,
                            },
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    WoodyClient.prototype.listGoogleDriveDrives = function (googleAccountId) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/integrations/google-drive/accounts/").concat(googleAccountId, "/drives"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated - use V2 API instead
     *
     * @returns { success: boolean } where success is true if the update is successful
     */
    WoodyClient.prototype.setUserPreferences = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/user/preferences"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: input,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @deprecated - use V2 API instead
     * @returns { success: boolean } where success is true if the update is successful
     */
    WoodyClient.prototype.getUserPreferences = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/user/preferences"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * @param date - the date to get the recap for, just toIsoString() any date object
     * @param frequency - how long the recap should be for - 'daily' is the only valid value at the moment
     * @param field - the timestamp field to use when grouping the resources - 'created' or 'modified'
     * @returns a json object with a summary/list of the user's resources created in the last 24h
     */
    WoodyClient.prototype.getUserRecapForDate = function (date, frequency, field) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/user/recap/by-date"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            query: {
                                date: date,
                                frequency: frequency,
                                field: field,
                            },
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     *
     * @returns RecapOptions the options for the dropdowns in the user recap preferences view
     */
    WoodyClient.prototype.getUserRecapPreferenceOptions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/user/recap-preference/options"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     *
     * @returns UserRecapPreference a user's preferences for the user recap
     */
    WoodyClient.prototype.getUserRecapPreference = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'GET',
                            url: "".concat(this.baseUrl, "/user/recap-preference"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     *
     * @returns { success: boolean } where success is true if the update is successful
     */
    WoodyClient.prototype.upsertUserRecapPreference = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/user/recap-preference"),
                            contentType: 'application/json',
                            authenticator: this.authenticator,
                            body: input,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     *
     * @returns { url: string } the url of the hosted image
     */
    WoodyClient.prototype.updateUserPicture = function (blob) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'POST',
                            url: "".concat(this.baseUrl, "/user/picture"),
                            contentType: 'image/*',
                            authenticator: this.authenticator,
                            body: blob,
                            rawBody: true,
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     *
     * @returns void
     */
    WoodyClient.prototype.deleteUserPicture = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.requestFactory.create({
                            authentication: Authentication.REQUIRED,
                            method: 'DELETE',
                            url: "".concat(this.baseUrl, "/user/picture"),
                            authenticator: this.authenticator,
                            contentType: 'application/json',
                        });
                        return [4 /*yield*/, request.send()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.JSON()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, {
                                status: response.status,
                                headers: response.headers,
                                error: response.error,
                                data: response.data,
                            }];
                }
            });
        });
    };
    /**
     * Register an event listener.
     *
     * @param type The name of event to listen for
     * @param listener The function to call when the event is triggered
     */
    WoodyClient.prototype.on = function (type, listener) {
        if (!this.eventListeners[type]) {
            this.eventListeners[type] = [];
        }
        this.eventListeners[type].push(listener);
    };
    /**
     * Remove an event listener.
     *
     * @param type The name of event to listen for
     * @param listener The function previously registered as a listener
     */
    WoodyClient.prototype.off = function (type, listener) {
        if (!this.eventListeners[type]) {
            return;
        }
        this.eventListeners[type] = this.eventListeners[type].filter(function (l) { return l !== listener; });
    };
    /**
     * Trigger event listeners for a given event.
     *
     * @param type The name of event to listen for
     * @param event The event object to pass to the listeners
     */
    WoodyClient.prototype.trigger = function (type, event) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                (_a = this.eventListeners[type]) === null || _a === void 0 ? void 0 : _a.forEach(function (listener) { return __awaiter(_this, void 0, void 0, function () {
                    var e_2;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, listener(event)];
                            case 1:
                                _a.sent();
                                return [3 /*break*/, 3];
                            case 2:
                                e_2 = _a.sent();
                                console.error("error in '".concat(type, "' event handler"), e_2);
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    return WoodyClient;
}());

exports.SpotifyUriType = void 0;
(function (SpotifyUriType) {
    SpotifyUriType["ALBUM"] = "album";
    SpotifyUriType["ARTIST"] = "artist";
    SpotifyUriType["EPISODE"] = "episode";
    SpotifyUriType["PLAYLIST"] = "playlist";
    SpotifyUriType["TRACK"] = "track";
})(exports.SpotifyUriType || (exports.SpotifyUriType = {}));

exports.FabricResourceTypes = void 0;
(function (FabricResourceTypes) {
    FabricResourceTypes["PAGE"] = "page";
    FabricResourceTypes["IMAGE"] = "image";
    FabricResourceTypes["TEXT"] = "text";
    FabricResourceTypes["NOTEPAD"] = "notepad";
    FabricResourceTypes["STORED_FILE"] = "stored_file";
    FabricResourceTypes["FOLDER"] = "folder";
})(exports.FabricResourceTypes || (exports.FabricResourceTypes = {}));

exports.ChatbotMessageRole = void 0;
(function (ChatbotMessageRole) {
    ChatbotMessageRole["user"] = "user";
    ChatbotMessageRole["assistant"] = "assistant";
})(exports.ChatbotMessageRole || (exports.ChatbotMessageRole = {}));
exports.ChatbotErrorCodes = void 0;
(function (ChatbotErrorCodes) {
    ChatbotErrorCodes["USAGE_LIMIT_EXCEEDED"] = "USAGE_LIMIT_EXCEEDED";
    ChatbotErrorCodes["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
})(exports.ChatbotErrorCodes || (exports.ChatbotErrorCodes = {}));

exports.FabricQueryMode = void 0;
(function (FabricQueryMode) {
    FabricQueryMode["Hybrid"] = "hybrid";
    FabricQueryMode["Keyword"] = "keyword";
    FabricQueryMode["SemanticImage"] = "semantic-image";
    FabricQueryMode["Semantictext"] = "semantic-text";
    FabricQueryMode["SimilarImage"] = "similar-image";
    FabricQueryMode["SimilarText"] = "similar-text";
})(exports.FabricQueryMode || (exports.FabricQueryMode = {}));
exports.FabricHitFamily = void 0;
(function (FabricHitFamily) {
    FabricHitFamily["Highlight"] = "highlight";
    FabricHitFamily["Image"] = "image";
    FabricHitFamily["Bookmark"] = "page";
    FabricHitFamily["File"] = "generic_file";
    FabricHitFamily["Note"] = "notepad";
})(exports.FabricHitFamily || (exports.FabricHitFamily = {}));

exports.GoogleDriveMirrorStatus = void 0;
(function (GoogleDriveMirrorStatus) {
    GoogleDriveMirrorStatus["PendingInitialIngest"] = "pending_initial_ingest";
    GoogleDriveMirrorStatus["InitialIngesting"] = "initial_ingest_in_progress";
    GoogleDriveMirrorStatus["Active"] = "active";
    GoogleDriveMirrorStatus["Disabled"] = "disabled";
})(exports.GoogleDriveMirrorStatus || (exports.GoogleDriveMirrorStatus = {}));

exports.MultiplayerSessionType = void 0;
(function (MultiplayerSessionType) {
    MultiplayerSessionType["YJS"] = "yjs";
})(exports.MultiplayerSessionType || (exports.MultiplayerSessionType = {}));

exports.IntegrationType = void 0;
(function (IntegrationType) {
    IntegrationType["GOOGLE_DRIVE"] = "GOOGLE_DRIVE";
    IntegrationType["GMAIL"] = "GMAIL";
    IntegrationType["GITHUB"] = "GITHUB";
    IntegrationType["IOS_DEVICE"] = "IOS_DEVICE";
    IntegrationType["ANDROID_DEVICE"] = "ANDROID_DEVICE";
    IntegrationType["RSS"] = "RSS";
    IntegrationType["NOTION"] = "NOTION";
    IntegrationType["LOCAL_FS"] = "LOCAL_FS";
    IntegrationType["DROPBOX"] = "DROPBOX";
    IntegrationType["ONEDRIVE"] = "ONEDRIVE";
    IntegrationType["MIXPANEL"] = "MIXPANEL";
    IntegrationType["STRIPE"] = "STRIPE";
    IntegrationType["EMAIL"] = "EMAIL";
})(exports.IntegrationType || (exports.IntegrationType = {}));
exports.IntegrationStatus = void 0;
(function (IntegrationStatus) {
    IntegrationStatus["ACTIVE"] = "ACTIVE";
    IntegrationStatus["INACTIVE"] = "INACTIVE";
})(exports.IntegrationStatus || (exports.IntegrationStatus = {}));
exports.ExtSourceTypes = void 0;
(function (ExtSourceTypes) {
    ExtSourceTypes[ExtSourceTypes["BOOKMARK"] = 1] = "BOOKMARK";
    ExtSourceTypes[ExtSourceTypes["SCREENSHOT"] = 2] = "SCREENSHOT";
    ExtSourceTypes[ExtSourceTypes["GOOGLE_DRIVE"] = 3] = "GOOGLE_DRIVE";
    ExtSourceTypes[ExtSourceTypes["GITHUB_STARS"] = 4] = "GITHUB_STARS";
    ExtSourceTypes[ExtSourceTypes["RSS_FEED"] = 5] = "RSS_FEED";
    ExtSourceTypes[ExtSourceTypes["NOTION_PAGE"] = 6] = "NOTION_PAGE";
    ExtSourceTypes[ExtSourceTypes["MOBILE_SYNC"] = 7] = "MOBILE_SYNC";
    ExtSourceTypes[ExtSourceTypes["LOCAL_FS"] = 8] = "LOCAL_FS";
    ExtSourceTypes[ExtSourceTypes["DROPBOX"] = 9] = "DROPBOX";
    ExtSourceTypes[ExtSourceTypes["GMAIL"] = 10] = "GMAIL";
    ExtSourceTypes[ExtSourceTypes["ONEDRIVE"] = 11] = "ONEDRIVE";
    ExtSourceTypes[ExtSourceTypes["EMAIL"] = 12] = "EMAIL";
})(exports.ExtSourceTypes || (exports.ExtSourceTypes = {}));
exports.MirrorStatus = void 0;
(function (MirrorStatus) {
    MirrorStatus["INITIALIZING"] = "initializing";
    MirrorStatus["ACTIVE"] = "active";
    MirrorStatus["PAUSED"] = "paused";
    MirrorStatus["FAILED"] = "failed";
    MirrorStatus["RETRYING"] = "retrying";
})(exports.MirrorStatus || (exports.MirrorStatus = {}));
exports.SubscriptionTier = void 0;
(function (SubscriptionTier) {
    SubscriptionTier["FREE"] = "free";
    SubscriptionTier["BASIC"] = "basic";
    SubscriptionTier["BASIC_LEGACY"] = "starter";
    SubscriptionTier["PRO"] = "pro";
    SubscriptionTier["MAX_LEGACY"] = "max";
    SubscriptionTier["LIFETIME"] = "lifetime";
})(exports.SubscriptionTier || (exports.SubscriptionTier = {}));
exports.UserGroup = void 0;
(function (UserGroup) {
    UserGroup["ADMIN"] = "admin";
    UserGroup["FABRIC_INTERNAL"] = "fabric-internal";
    UserGroup["INVESTOR"] = "investor";
    UserGroup["DOGFOODING"] = "dogfooding";
    UserGroup["BETA_GOOGLE_DRIVE"] = "google-drive-beta";
    UserGroup["BETA_USER_RECAP"] = "beta-user-recap";
    UserGroup["LOCAL_FILE_SYNC"] = "local-file-sync";
    UserGroup["NOTEPAD_DIFFS"] = "notepad-diffs";
})(exports.UserGroup || (exports.UserGroup = {}));
exports.PermissionRole = void 0;
(function (PermissionRole) {
    PermissionRole["OWNER"] = "owner";
    PermissionRole["VIEWER"] = "viewer";
    PermissionRole["EDITOR"] = "editor";
    PermissionRole["COMMENTER"] = "commenter";
})(exports.PermissionRole || (exports.PermissionRole = {}));
exports.Kind = void 0;
(function (Kind) {
    Kind["DEFAULT_FILE"] = "default";
    Kind["IMAGE"] = "image";
    Kind["DOCUMENT"] = "document";
    Kind["FOLDER"] = "folder";
    Kind["BOOKMARK"] = "bookmark";
    Kind["HIGHLIGHT"] = "highlight";
    Kind["NOTEPAD"] = "notepad";
    Kind["VIDEO"] = "video";
    Kind["AUDIO"] = "audio";
    Kind["EMAIL"] = "email";
    Kind["PERSON"] = "person";
})(exports.Kind || (exports.Kind = {}));
exports.HtmlPreviewType = void 0;
(function (HtmlPreviewType) {
    HtmlPreviewType["LINK"] = "link";
    HtmlPreviewType["SPOTIFY"] = "spotify";
    HtmlPreviewType["GOOGLE"] = "google";
})(exports.HtmlPreviewType || (exports.HtmlPreviewType = {}));
exports.RootAlias = void 0;
(function (RootAlias) {
    RootAlias["INBOX"] = "@alias::inbox";
})(exports.RootAlias || (exports.RootAlias = {}));
exports.NoteType = void 0;
(function (NoteType) {
    NoteType["TEXT"] = "text";
    NoteType["PAGE"] = "page";
    NoteType["IMAGE"] = "image";
})(exports.NoteType || (exports.NoteType = {}));
exports.MimeTypes = void 0;
(function (MimeTypes) {
    MimeTypes["VND_FABRIC_FOLDER"] = "application/vnd.fabric.folder";
    MimeTypes["VND_FABRIC_NOTEPAD"] = "application/vnd.fabric.notepad";
    MimeTypes["VND_FABRIC_BOOKMARK"] = "application/vnd.fabric.bookmark";
    MimeTypes["VND_FABRIC_HIGHLIGHT"] = "application/vnd.fabric.highlight";
    MimeTypes["VND_FABRIC_EMAIL"] = "application/vnd.fabric.email";
    MimeTypes["VND_FABRIC_PERSON"] = "application/vnd.fabric.person";
})(exports.MimeTypes || (exports.MimeTypes = {}));
exports.RootType = void 0;
(function (RootType) {
    RootType["SYSTEM"] = "SYSTEM";
    RootType["SPACE"] = "SPACE";
    RootType["INTEGRATION"] = "INTEGRATION";
})(exports.RootType || (exports.RootType = {}));
exports.SystemSubtypes = void 0;
(function (SystemSubtypes) {
    SystemSubtypes["INBOX"] = "inbox";
})(exports.SystemSubtypes || (exports.SystemSubtypes = {}));
exports.ProcessingState = void 0;
(function (ProcessingState) {
    ProcessingState["PENDING"] = "pending";
    ProcessingState["PROCESSING"] = "processing";
    ProcessingState["COMPLETED"] = "completed";
    ProcessingState["FAILED"] = "failed";
})(exports.ProcessingState || (exports.ProcessingState = {}));
exports.PrecessingJob = void 0;
(function (PrecessingJob) {
    PrecessingJob["ATTRIBUTES"] = "attributes";
})(exports.PrecessingJob || (exports.PrecessingJob = {}));
exports.ThumbnailSize = void 0;
(function (ThumbnailSize) {
    ThumbnailSize["SM"] = "sm";
    ThumbnailSize["MD"] = "md";
    ThumbnailSize["LG"] = "lg";
    ThumbnailSize["XL"] = "xl";
    ThumbnailSize["ORIGINAL"] = "original";
})(exports.ThumbnailSize || (exports.ThumbnailSize = {}));
exports.AnnouncementType = void 0;
(function (AnnouncementType) {
    AnnouncementType["ANNOUNCEMENT"] = "announcement";
    AnnouncementType["DANGER"] = "danger";
    AnnouncementType["WARNING"] = "warning";
    AnnouncementType["INFO"] = "info";
    AnnouncementType["PROMOTIONAL"] = "promotional";
    AnnouncementType["LIGHT_INFORMATIONAL"] = "light-informational";
    AnnouncementType["STRONG_INFORMATIONAL"] = "strong-informational";
    AnnouncementType["URGENT"] = "urgent";
})(exports.AnnouncementType || (exports.AnnouncementType = {}));
exports.SignupCodeDeliveryMethod = void 0;
(function (SignupCodeDeliveryMethod) {
    SignupCodeDeliveryMethod["EMAIL"] = "EMAIL";
    SignupCodeDeliveryMethod["SMS"] = "SMS";
})(exports.SignupCodeDeliveryMethod || (exports.SignupCodeDeliveryMethod = {}));
exports.QueryMode = void 0;
(function (QueryMode) {
    QueryMode["HYBRID"] = "hybrid";
    QueryMode["KEYWORD"] = "keyword";
    QueryMode["SEMANTIC_IMAGE"] = "semantic-image";
    QueryMode["SEMANTIC_TEXT"] = "semantic-text";
    QueryMode["SIMILAR_IMAGE"] = "similar-image";
    QueryMode["SIMILAR_TEXT"] = "similar-text";
})(exports.QueryMode || (exports.QueryMode = {}));
exports.ResourceExportLogStatus = void 0;
(function (ResourceExportLogStatus) {
    ResourceExportLogStatus["PENDING"] = "PENDING";
    ResourceExportLogStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ResourceExportLogStatus["SUCCESS"] = "SUCCESS";
    ResourceExportLogStatus["ERROR"] = "ERROR";
    ResourceExportLogStatus["CLEANED"] = "CLEANED";
})(exports.ResourceExportLogStatus || (exports.ResourceExportLogStatus = {}));
exports.ServiceHealthStatus = void 0;
(function (ServiceHealthStatus) {
    ServiceHealthStatus["OK"] = "ok";
    ServiceHealthStatus["ERROR"] = "error";
    ServiceHealthStatus["TIMEOUT"] = "timeout";
})(exports.ServiceHealthStatus || (exports.ServiceHealthStatus = {}));
exports.HealthStatus = void 0;
(function (HealthStatus) {
    HealthStatus["OK"] = "ok";
    HealthStatus["ERROR"] = "error";
})(exports.HealthStatus || (exports.HealthStatus = {}));
exports.ImporterType = void 0;
(function (ImporterType) {
    ImporterType["EVERNOTE"] = "evernote";
    ImporterType["OMNIVORE"] = "omnivore";
    ImporterType["MYMIND"] = "mymind";
    ImporterType["CHROME"] = "chrome";
    ImporterType["EDGE"] = "edge";
    ImporterType["FIREFOX"] = "firefox";
    ImporterType["SAFARI"] = "safari";
    ImporterType["POCKET"] = "pocket";
    ImporterType["POCKET_ZIP"] = "pocket_zip";
    ImporterType["RAINDROP"] = "raindrop";
})(exports.ImporterType || (exports.ImporterType = {}));
exports.ResourceImportStatuses = void 0;
(function (ResourceImportStatuses) {
    ResourceImportStatuses["PENDING"] = "pending";
    ResourceImportStatuses["ATTEMPTING"] = "attempting";
    ResourceImportStatuses["PARSED"] = "parsed";
    ResourceImportStatuses["PARTIAL"] = "partially_completed";
    ResourceImportStatuses["COMPLETED"] = "completed";
    ResourceImportStatuses["FAILED"] = "failed";
})(exports.ResourceImportStatuses || (exports.ResourceImportStatuses = {}));
exports.EmbeddingModel = void 0;
(function (EmbeddingModel) {
    EmbeddingModel["SMALL3_512"] = "small3-512";
    EmbeddingModel["CLIP2"] = "clip2";
})(exports.EmbeddingModel || (exports.EmbeddingModel = {}));
exports.MirrorSyncOperation = void 0;
(function (MirrorSyncOperation) {
    MirrorSyncOperation["UPLOAD"] = "UPLOAD";
    MirrorSyncOperation["RE_UPLOAD"] = "RE_UPLOAD";
    MirrorSyncOperation["DOWNLOAD"] = "DOWNLOAD";
    MirrorSyncOperation["RENAME"] = "RENAME";
    MirrorSyncOperation["MOVE"] = "MOVE";
    MirrorSyncOperation["DELETE"] = "DELETE";
    MirrorSyncOperation["VIRTUAL"] = "VIRTUAL";
    MirrorSyncOperation["SET_ID"] = "SET_ID";
})(exports.MirrorSyncOperation || (exports.MirrorSyncOperation = {}));
exports.RecapHour = void 0;
(function (RecapHour) {
    RecapHour[RecapHour["TWELVE_AM"] = 0] = "TWELVE_AM";
    RecapHour[RecapHour["ONE_AM"] = 1] = "ONE_AM";
    RecapHour[RecapHour["TWO_AM"] = 2] = "TWO_AM";
    RecapHour[RecapHour["THREE_AM"] = 3] = "THREE_AM";
    RecapHour[RecapHour["FOUR_AM"] = 4] = "FOUR_AM";
    RecapHour[RecapHour["FIVE_AM"] = 5] = "FIVE_AM";
    RecapHour[RecapHour["SIX_AM"] = 6] = "SIX_AM";
    RecapHour[RecapHour["SEVEN_AM"] = 7] = "SEVEN_AM";
    RecapHour[RecapHour["EIGHT_AM"] = 8] = "EIGHT_AM";
    RecapHour[RecapHour["NINE_AM"] = 9] = "NINE_AM";
    RecapHour[RecapHour["TEN_AM"] = 10] = "TEN_AM";
    RecapHour[RecapHour["ELEVEN_AM"] = 11] = "ELEVEN_AM";
    RecapHour[RecapHour["TWELVE_PM"] = 12] = "TWELVE_PM";
    RecapHour[RecapHour["ONE_PM"] = 13] = "ONE_PM";
    RecapHour[RecapHour["TWO_PM"] = 14] = "TWO_PM";
    RecapHour[RecapHour["THREE_PM"] = 15] = "THREE_PM";
    RecapHour[RecapHour["FOUR_PM"] = 16] = "FOUR_PM";
    RecapHour[RecapHour["FIVE_PM"] = 17] = "FIVE_PM";
    RecapHour[RecapHour["SIX_PM"] = 18] = "SIX_PM";
    RecapHour[RecapHour["SEVEN_PM"] = 19] = "SEVEN_PM";
    RecapHour[RecapHour["EIGHT_PM"] = 20] = "EIGHT_PM";
    RecapHour[RecapHour["NINE_PM"] = 21] = "NINE_PM";
    RecapHour[RecapHour["TEN_PM"] = 22] = "TEN_PM";
    RecapHour[RecapHour["ELEVEN_PM"] = 23] = "ELEVEN_PM";
})(exports.RecapHour || (exports.RecapHour = {}));
exports.RecapWeekDay = void 0;
(function (RecapWeekDay) {
    RecapWeekDay["MONDAY"] = "monday";
    RecapWeekDay["TUESDAY"] = "tuesday";
    RecapWeekDay["WEDNESDAY"] = "wednesday";
    RecapWeekDay["THURSDAY"] = "thursday";
    RecapWeekDay["FRIDAY"] = "friday";
    RecapWeekDay["SATURDAY"] = "saturday";
    RecapWeekDay["SUNDAY"] = "sunday";
})(exports.RecapWeekDay || (exports.RecapWeekDay = {}));
exports.RecapMonthDay = void 0;
(function (RecapMonthDay) {
    RecapMonthDay["FIRST_DAY_OF_MONTH"] = "first_day_of_month";
    RecapMonthDay["MID_MONTH"] = "mid_month";
    RecapMonthDay["LAST_DAY_OF_MONTH"] = "last_day_of_month";
})(exports.RecapMonthDay || (exports.RecapMonthDay = {}));
exports.ResourceActivityEvent = void 0;
(function (ResourceActivityEvent) {
    ResourceActivityEvent["RESOURCE_CREATED"] = "RESOURCE_CREATED";
    ResourceActivityEvent["RESOURCE_UPDATED"] = "RESOURCE_UPDATED";
    ResourceActivityEvent["RESOURCE_MOVED"] = "RESOURCE_MOVED";
    ResourceActivityEvent["RESOURCE_COPIED"] = "RESOURCE_COPIED";
    ResourceActivityEvent["COMMENT_CREATED"] = "COMMENT_CREATED";
    ResourceActivityEvent["COMMENT_UPDATED"] = "COMMENT_UPDATED";
    ResourceActivityEvent["COMMENT_DELETED"] = "COMMENT_DELETED";
    ResourceActivityEvent["INTEGRATION_SYNC_FINISHED"] = "INTEGRATION_SYNC_FINISHED";
    ResourceActivityEvent["LABEL_SET"] = "LABEL_SET";
    ResourceActivityEvent["TAG_CREATED"] = "TAG_CREATED";
    ResourceActivityEvent["TAG_DELETED"] = "TAG_DELETED";
    ResourceActivityEvent["MEMBER_JOINED"] = "MEMBER_JOINED";
    ResourceActivityEvent["MEMBER_LEFT"] = "MEMBER_LEFT";
})(exports.ResourceActivityEvent || (exports.ResourceActivityEvent = {}));
exports.UsageType = void 0;
(function (UsageType) {
    UsageType["STORAGE"] = "storage";
    UsageType["CHATBOT"] = "chatbot";
    UsageType["CREDITS"] = "credits";
})(exports.UsageType || (exports.UsageType = {}));
exports.CreditOperation = void 0;
(function (CreditOperation) {
    CreditOperation["RESOURCE_CREATED"] = "RESOURCE_CREATED";
    CreditOperation["ASSISTANT_MESSAGE"] = "ASSISTANT_MESSAGE";
    CreditOperation["TOP_UP_MANUAL"] = "TOP_UP_MANUAL";
    CreditOperation["TOP_UP_PLAN"] = "TOP_UP_PLAN";
})(exports.CreditOperation || (exports.CreditOperation = {}));
exports.AdminTask = void 0;
(function (AdminTask) {
    AdminTask["GEN_THUMBNAILS"] = "generate-video-and-pdf-thumbnails";
    AdminTask["MIGRATE_RESOURCE_NAMES"] = "migrate-resource-names";
    AdminTask["MIGRATE_SUBSCRIPTIONS"] = "migrate-subscriptions";
    AdminTask["PROCESS_PENDING_RESOURCES"] = "process-pending-resources";
    AdminTask["RESYNC_INTEGRATION_RESOURCES"] = "resync-integration-resources";
    AdminTask["BACKFILL_FILE_SIZES"] = "backfill-file-sizes";
    AdminTask["BACKFILL_EXTENSIONS"] = "backfill-extensions";
    AdminTask["REINDEX_DELETED_INTEGRATION_RESOURCES"] = "reindex-deleted-integration-resources";
    AdminTask["REINDEX_RESOURCES"] = "reindex-resources";
    AdminTask["REINDEX_RESOURCE_USERS"] = "reindex-resource-users";
    AdminTask["REQUEUE_RESOURCE_PROCESSING"] = "requeue-resource-processing";
    AdminTask["BACKFILL_BOOKMARK_PREVIEW"] = "backfill-bookmark-preview";
    AdminTask["BACKFILL_BOOKMARK_PREVIEW_EMPTY"] = "backfill-bookmark-preview-empty";
    AdminTask["BACKFILL_BOOKMARK_CONTEXT"] = "backfill-bookmark-context";
    AdminTask["BACKFILL_LINK_PREVIEWS"] = "backfill-link-previews";
    AdminTask["REFRESH_SOCIAL_LINK_PREVIEWS"] = "refresh-social-link-previews";
    AdminTask["BACKFILL_DOCUMENT_KIND"] = "backfill-document-kind";
    AdminTask["BACKFILL_REVENUECAT"] = "backfill-revenuecat";
    AdminTask["BACKFILL_TRANSCRIPT_STORAGE_KEY"] = "backfill-transcript-storage-key";
    AdminTask["BACKFILL_CREDITS"] = "backfill-credits";
    AdminTask["TRIGGER_RESOURCE_CLEANUP"] = "trigger-resource-cleanup";
    AdminTask["RESOLVE_RESOURCE_UNIQUE_NAMES"] = "resolve-resource-unique-names";
    AdminTask["INDEX_CLEANUP_DELETED"] = "index-cleanup-deleted";
    AdminTask["FIX_FABRIC_BRIDGE_BOOKMARKS"] = "fix-fabric-bridge-bookmarks";
})(exports.AdminTask || (exports.AdminTask = {}));
exports.OauthProvider = void 0;
(function (OauthProvider) {
    OauthProvider["GOOGLE"] = "google";
    OauthProvider["APPLE"] = "apple";
})(exports.OauthProvider || (exports.OauthProvider = {}));
exports.RoomType = void 0;
(function (RoomType) {
    RoomType["SPACE"] = "space";
    RoomType["RESOURCE"] = "resource";
    RoomType["FOLDER"] = "folder";
})(exports.RoomType || (exports.RoomType = {}));
exports.TrackingEvent = void 0;
(function (TrackingEvent) {
    TrackingEvent["VISITED_PRICING"] = "visited_pricing";
})(exports.TrackingEvent || (exports.TrackingEvent = {}));

exports.WoodyClient = WoodyClient;
exports.default = WoodyClient;
